import PropTypes from 'prop-types';
import { compose, filter, indexBy, path, prop, reverse, sortBy } from 'ramda';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import { openLeftBarModule } from '../modules/actions/layout';
import { readEndpointDedup } from '../modules/reducers/api';
import { selectRailways } from '../modules/selectors/railway';

class RouteBlockageList extends Component {
  static propTypes = {
    routeBlockages: PropTypes.array.isRequired,
    openLeftBarModule: PropTypes.func.isRequired,
  };

  componentDidMount () {
    const { readEndpointDedup } = this.props;

    // Call 'recent' instead of filtering for ended-at__isnull=True, because
    // this way we can take advantage of any in-flight calls for recent route
    // blockages issues from AppBase's frequentInterval.
    readEndpointDedup('route-blockage?recent=True');
  }

  render () {
    return (
      <List>
        {this.props.routeBlockages.map(item => this.renderRouteBlockageItem(item))}
      </List>
    )
  }

  renderRouteBlockageItem = (item) => {
    const { openLeftBarModule } = this.props;

    const railwayId = path(['relationships', 'railway', 'data', 'id'], item);
    const stopFromId = path(['relationships', 'stop-from', 'data', 'id'], item);
    const stopToId = path(['relationships', 'stop-to', 'data', 'id'], item);

    const railway = this.props.railways[railwayId];
    const stopFrom = this.props.stops[stopFromId];
    const stopTo = this.props.stops[stopToId];

    return (
      <Fragment key={item.id}>
        <div onClick={() => openLeftBarModule('routeBlockage', 'routeBlockageEdit', { type: 'edit', id: item.id })}>
          <ListItem
            button
            alignItems="flex-start"
            key={item.id}
          >
            <ListItemText
              primary={`\`${stopFrom.attributes.name} naar ${stopTo.attributes.name}\``}
              secondary={railway && railway.attributes.name || 'Onbekend'}
            />
          </ListItem>
        </div>

        <Divider variant="inset" component="li" />
      </Fragment>
    );
  };
}


const selectRouteBlockages = (state) => {
  const routeBlockages = path(['api', 'route-blockage', 'data'], state) || [];

  const isActive = routeBlockage => {
    const endedAt = path(['attributes', 'ended-at'], routeBlockage);

    return !endedAt;
  };

  const activeRouteBlockages = filter(isActive)(routeBlockages);

  const makeInt = v => parseInt(v, 10);

  const sortedActiveRouteBlockages = sortBy(compose(makeInt, prop('id')))(activeRouteBlockages);

  return reverse(sortedActiveRouteBlockages);
};

const selectRailwayIds = (state) => {
  const railways = selectRailways(state);

  return indexBy(prop('id'), railways);
};

const selectStops = (state) => {
  const stops = state.api.stop && state.api.stop.data || [];

  return indexBy(prop('id'), stops);
};

const mapStateToProps = (state) => ({
  routeBlockages: selectRouteBlockages(state),
  railways: selectRailwayIds(state),
  stops: selectStops(state),
});

const mapDispatchToProps = {
  readEndpointDedup,
  openLeftBarModule,
};

export default connect(mapStateToProps, mapDispatchToProps)(RouteBlockageList);
